import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { ToastContainer } from 'react-toastify';
//////////////////////////////////////////////////////////////////////
import { appRoutes } from './routes';
import { MainLayout } from '@/app/shared/components';

import './i18n';

function App() {
	if (process.env.VITE_GA_CODE) {
		ReactGA.initialize(process.env.VITE_GA_CODE);
	}

	return (
		<>
      {/* Toast container for all toast messages */}
      <ToastContainer
        position="bottom-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<MainLayout />}>
            {appRoutes}
          </Route>
          <Route path="*" element={<Navigate to="/not-found" />} />
        </Routes>
      </BrowserRouter>
    </>
	);
}

export default App;
